import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export default function ClientGuideAnimated() {
  const {t} = useTranslation()
  const steps = [
    {
      title: t('steptitle'),
      description: t('desc')
    },
    {
      title:t('steptitle1'),
      description: t('desc1')
    },
    {
      title: t('steptitle2'),
      description: t('desc2')
    }
  ];

  return (
    <section className="bg-white py-16">
      <div className="max-w-5xl mx-auto px-6 lg:px-8 space-y-12">

        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-4xl font-bold text-orange-500 text-center"
        >
          {t('ht')}
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.6 }}
          className="text-center text-xl text-gray-600 max-w-2xl mx-auto"
        >
            {t('ht1')}
        </motion.p>

        <div className="grid gap-8 md:grid-cols-3">

          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="bg-white shadow-md rounded-xl p-6 hover:shadow-xl transition cursor-pointer"
            >
              <h3 className="text-xl font-semibold text-[#42AB3F] mb-3">{step.title}</h3>
              <p className="text-gray-700 font-semibold text-sm">{step.description}</p>
            </motion.div>
          ))}

        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.8, duration: 0.6 }}
          className="text-center text-md mt-8 text-gray-600"
        >
          {t('ht2')}
        </motion.div>

      </div>
    </section>
  );
}